export enum GameFormVariant {
  Login = 'login',
  Register = 'register',
}
